import React from 'react'

import { ConfirmationDialog, DialogContent } from '@front/squirtle'
import DuplicateOrders from './duplicateOrders'

const Component = ({ handleSubmit }) =>
  <ConfirmationDialog
    name={'show_duplicate_orders'}
    onConfirm={handleSubmit}
    maxWidth='xl'
  >
    <DialogContent>
      <DuplicateOrders />
    </DialogContent>
  </ConfirmationDialog>


export default Component
